import React, { useEffect, useState } from 'react'
import s from './Header.module.css'
import NavBar from '../navBar/NavBar'
import logo from '../../assets/img/logo.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { HOME, LOGIN, OPEN_ACCOUNT } from '../../router/Constants'
import menu from '../../assets/img/mobile/menu.svg'
import { userSlice } from '../../store/reducers/UserSlice'
import { useAppDispatch } from '../../hooks/redux'
import CustomBtnBlue from '../ui/customBtnBlue/CustomBtnBlue'
import { useTranslation } from 'react-i18next';
import LanguageDropdown from '../ui/LanguageDropdown/LanguageDropdown'


type PropsType = {
  setIsMobileMenuActive: (boolean: boolean) => void
}

const Header = (props: PropsType) => {
  const navigate = useNavigate()

  const location = useLocation()
  const [isNavShow, setIsNavShow] = useState(false)
  const [isLoginPage, setIsLoginPage] = useState(false)
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (location.pathname.includes('open_account')) {
      setIsNavShow(false)
    } else if (location.pathname.includes('log_in')) {
      setIsNavShow(false)
      setIsLoginPage(true)
    } else {
      setIsNavShow(true)
      setIsLoginPage(false)
    }
  }, [location.pathname])
  const { setMessageSentSuccess } = userSlice.actions
  const dispatch = useAppDispatch()

  const redirect = () => {
    navigate(LOGIN)
    dispatch(setMessageSentSuccess(null))
  }

  useEffect(() => {
    const lang = i18n.language;
    const isRtl = lang === 'fas';
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.body.className = isRtl ? 'rtl' : 'ltr';
  }, []);


  return (
    <div className={s.wrapper}>
      <div className={s.content} dir='ltr'>
        <Link to={HOME}>
          <img src={logo} alt='' className={s.logo} />
        </Link>
        {isNavShow ? (
            <div className={s.buttons_block}>
             <LanguageDropdown />


              <div className={s.login_btn_wrapper}>
                <CustomBtnBlue
                    title={t('header.login')}
                    onClick={() => navigate(LOGIN)}
                />
              </div>
              <div className={s.btn_open_block}>
                <CustomBtnBlue
                    title={t('header.openAccount')}
                    onClick={() => navigate(OPEN_ACCOUNT)}
                />
              </div>
            </div>
        ) : (
            <div className={s.buttons_block}>
              {isLoginPage ? (
                  <CustomBtnBlue title={t('header.back')}
                onClick={() => navigate(-1)}
              />
            ) : (
              <CustomBtnBlue
                  title={t('header.login')}
                onClick={() => redirect()}
              />
            )}
          </div>
        )}
        <div className={s.mobile_flex}>
          <div>
            <img
              onClick={() => props.setIsMobileMenuActive(true)}
              src={menu}
              alt=''
            />
          </div>
        </div>
      </div>

      {isNavShow ? (
        <div className={s.navbar_wrapper}>
          <NavBar />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default Header
